
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_32007_149849)"}},[_c('path',{attrs:{"d":"M7 3.25a1.25 1.25 0 112.5 0v4.631a1.5 1.5 0 012.497 1.003 1.5 1.5 0 012.5 1A1.5 1.5 0 0117 11v3a4 4 0 01-4 4H10.336c-.156 0-.31-.01-.46-.031A6.261 6.261 0 015.502 15.5l-2.25-3a1.248 1.248 0 01.25-1.75 1.248 1.248 0 011.75.25L7 13.334V3.25z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_32007_149849"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3 2)","d":"M0 0h14v16H0z"}})])])])
          )
        }
      }
    